import {
  GET_MICRO_LOANS_SETTINGS_DATA_ERROR,
  GET_MICRO_LOANS_SETTINGS_DATA_START,
  GET_MICRO_LOANS_SETTINGS_DATA_SUCCESS,
} from 'constants/action-types/settings/getMicroLoansSettingData';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_MICRO_LOANS_SETTINGS_DATA_START:
      return {
        ...state,
        microloanSettingsData: {
          ...state.microloanSettingsData,
          loading: true,
          error: null,
          data: null,
        },
      };
    case GET_MICRO_LOANS_SETTINGS_DATA_ERROR:
      return {
        ...state,
        microloanSettingsData: {
          ...state.microloanSettingsData,
          error: payload,
          loading: false,
        },
      };
    case GET_MICRO_LOANS_SETTINGS_DATA_SUCCESS:
      return {
        ...state,
        microloanSettingsData: {
          ...state.microloanSettingsData,
          data: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
